// src/components/organism/SixDetail/ActivityFeed/ActivityItem.tsx

import React from "react";
import { Col, Container, Row } from "shared-portal-component";

import ActivityHeaderRow from "@/components/molecules/ActivityHeader/ActivityHeader";
import ActivityTextComponent from "@/components/atomic/ActivityTextComponent/ActivityTextComponent";

interface ActivityItemProps {
  title: string;
  time: string;
  files: string[];
}

const ActivityItem: React.FC<ActivityItemProps> = ({
  title,
  time,
  files,
}) => (
    <Row spacing="none">
      <Col>
    <ActivityHeaderRow  title={title} time={time} />
    <Container>
    <ul className="activity-files">
      {files.map((file, idx) => (
        <Row spacing="none" justify="start">
        <li
          key={file + idx}
        >
        <ActivityTextComponent>  {file} </ActivityTextComponent>
        </li>
        </Row>
      ))}
    </ul>
    </Container>
    </Col>
    </Row>
);

export default ActivityItem;
